import { render } from "./H5Payment.vue?vue&type=template&id=5b0370f2&scoped=true"
import script from "./H5Payment.vue?vue&type=script&lang=js"
export * from "./H5Payment.vue?vue&type=script&lang=js"

import "./H5Payment.vue?vue&type=style&index=0&id=5b0370f2&scoped=true&lang=css"
import "./H5Payment.vue?vue&type=style&index=1&id=5b0370f2&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0370f2"]])

export default __exports__